import type { Dance, PlaybackAudioTrack } from "@recital-master/shared";
import { danceStyleLabel } from "@recital-master/shared";

import { displayTitle, joinWithDot } from "../../lib/format";

export type VideoSurfaceMetadata = {
  title: string;
  artist: string;
  artwork: string;
};

export type VideoSurfaceSource = {
  danceId: string;
  uri: string;
  audioTracks: PlaybackAudioTrack[];
  metadata: VideoSurfaceMetadata;
};

export function buildDanceVideoSource({
  uri,
  dance,
  resolvedThumbnailUrl,
  performanceArtworkUrl,
  recitalArtworkUrl
}: {
  uri: string;
  dance: Pick<
    Dance,
    "danceId" | "title" | "styles" | "className" | "audioTracks"
  >;
  resolvedThumbnailUrl: string | null;
  performanceArtworkUrl: string | null;
  recitalArtworkUrl: string;
}): VideoSurfaceSource {
  return {
    danceId: dance.danceId,
    uri,
    audioTracks: dance.audioTracks,
    metadata: {
      title: displayTitle(dance.title),
      artist: joinWithDot([danceStyleLabel(dance), dance.className]),
      artwork: resolvedThumbnailUrl ?? performanceArtworkUrl ?? recitalArtworkUrl
    }
  };
}
